import { useKioskSession } from "~/stores/kiosk-session/hooks/use-kiosk-session";
import { kioskUsesCustomShopperName } from "~/utils/kiosk-requires-order-instructions";
import { resolveKioskShopperName } from "~/utils/resolve-kiosk-shopper-name";

import { useKioskStore } from "./route";

/** The name to put on the order, shared by the basket field and the payload. */
export function useKioskShopperName(): string | null {
  const till = useKioskStore((state) => state.till);
  const identifiedUserName = useKioskStore((state) => state.user?.name);
  const answeredName = useKioskSession((session) => session?.shopperName);

  return resolveKioskShopperName({
    answeredName,
    identifiedUserName,
    usesCustomShopperName: kioskUsesCustomShopperName(till)
  });
}
